module.exports = __webpack_public_path__ + "static/img/logo@1x.4ef6543.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/logo@1x.png
// module id = ho08
// module chunks = 79